const rules =
{
    required: [v => !!v || 'This field is required'],
    minQty: v => v > 0 || 'You need to order at least 1',
    maxQty: v => v <= 1000 || 'Maximum is 1000',
    minBw: v => v > 0 || 'You need to order at least 1',
    maxBw: v => v <= 10000 || 'Maximum is 10000',
    ipaddress: [v => /^(?!0\.|10\.|100\.[6-9]\d\.|100\.1[0-1]\d\.|169\.254\.|172\.(1[6-9]|2\d|3[01])\.|192\.0\.0\.|192\.0\.2\.|192\.88\.99\.|192\.168\.|198\.18\.|198\.51\.100\.|203\.0\.113\.|22[4-9]\.|23[0-9]\.|24[0-9]\.|25[0-5]\.)(25[0-5]|2[0-4]\d|[01]?\d{1,2})\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})\.(25[0-5]|2[0-4]\d|[01]?\d{1,2})$/.test(v) || 'IP address is invalid']
}
export default rules